export default {
    buttons: {
        lecture: '与老师一起',
        self: '自主学习',
    },
    moduleLabel: {
        cardWriting: '卡片书写 💬️',
        wordCheck: '词语侦探',
        wordWriting: '听写',
        wordSelection: '选词',
        seedLetter: '字根',
        oxQuiz: 'OX 测验',
        fillInTheBlanks: '填空',
        proConDebate: '辩论',
        segmentedReading: '导读',
        sentenceOrdering: '句子排序',
        correctTheMistakes: '纠正错误',
        postIt: '完成表格',
        magicWordTest: '我知道！不知道？',
        talkQuiz: '对话测验',
    },
};
